define([
    'jquery',
    '../console',
    '../globals'
], function($, console, globals) {

    var _template = 'about';
    var tm = require('../vendor/gsap/gsap').TweenMax;
    var CSSRulePlugin = require('../vendor/gsap/CSSRulePlugin');

    const _enableEventHandlers = function() {};
    const _disableEventHandlers = function() {};

    const animateIn = function(callback) {
        if ($('.viewport').data('template') !== _template) {
            return false;
        }

        _enableEventHandlers();

        tm.to($('.page-row-expanded'), 0.3, {
            css: {opacity: 1}, onComplete: function () {
                if (callback && typeof (callback) === "function") {
                    return (callback());
                }
            }
        });
    }

    const animateOut = function (callback) {
        if ($('.viewport').data('template') !== _template) {
            return false;
        }

        _disableEventHandlers();

        tm.to($('.page-row-expanded'), 0.3, {
            css: {opacity: 0}, onComplete: function () {
                if (callback && typeof (callback) === "function") {
                    return (callback());
                }
            }
        });
    }

    return {
        animateIn: animateIn,
        animateOut: animateOut
    }
});